// Auth Repository - OOP Pattern (Repository Pattern)
import { IApiClient } from '../interfaces/IApiClient';
import { IUser, IAuthResponse } from '../interfaces/IUser';
import { LoginDto, RegisterDto, ForgotPasswordDto, ResetPasswordDto, AcceptInviteDto } from '../dto/AuthDto';

export class AuthRepository {
  constructor(private apiClient: IApiClient) {}

  async login(dto: LoginDto): Promise<IAuthResponse> {
    return this.apiClient.post<IAuthResponse>('/auth/login', {
      email: dto.email,
      password: dto.password,
    });
  }

  async register(dto: RegisterDto): Promise<IAuthResponse> {
    return this.apiClient.post<IAuthResponse>('/auth/register', {
      email: dto.email,
      password: dto.password,
      name: dto.name,
    });
  }

  async forgotPassword(dto: ForgotPasswordDto): Promise<{ message: string }> {
    return this.apiClient.post<{ message: string }>('/auth/forgot-password', {
      email: dto.email,
    });
  }

  async resetPassword(dto: ResetPasswordDto): Promise<{ message: string }> {
    return this.apiClient.post<{ message: string }>('/auth/reset-password', {
      token: dto.token,
      password: dto.password,
    });
  }

  async acceptInvite(dto: AcceptInviteDto): Promise<{ message: string }> {
    return this.apiClient.post<{ message: string }>('/auth/accept-invite', {
      token: dto.token,
      password: dto.password,
    });
  }

  async getCurrentUser(): Promise<IUser> {
    return this.apiClient.get<IUser>('/auth/me');
  }
}
